module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iNKPN"))).then(() => parcelRequire('2KbAe'));